import { OverlayTrigger } from 'react-bootstrap';
import { formatNumberWithComma } from '../../../../components/functions/utilities';
import { useAppSelector } from '../../../../redux/reduxHooks';
import styles from './CardContainer.module.scss'
import { MdInfo } from 'react-icons/md'
import { GoalsHubTooltip } from '../../../ReportDetails/Components/ReportTabs/TabsContent/reportDataPiece/tooltip/Tooltip.styled';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import { MdOutlineEdit } from 'react-icons/md'
import { useState } from 'react';
import RequestChange from './RequestChange/RequestChange';

const SalesMarketingCardContainer = ({ card, updateCard }) => {
  const { integrationPartners } = useAppSelector(state => state.config);

  const iButton = (dataSource) => {
    return (
      dataSource == 'Shopify' ?
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => {
            const updatedProps = {
              ...props, maxWidth: 'max-content'
            }
            return (
              <GoalsHubTooltip {...updatedProps} >
                <div className={styles.iButtonContainer}>
                  <p>Why Merito Sales May Not Match Shopify</p><br />
                  {/* <ul> */}
                  {
                    ["Merito shows net sales after cancellations.",
                      "Shopify shows it on the cancellation date.",
                      "We assign sales to the actual order date."].map(para => <li>{para}</li>)
                  }
                  {/* </ul> */}
                </div>
              </GoalsHubTooltip>
            )
          }
          }
        >
          <div>
            <MdInfo />
          </div>
        </OverlayTrigger > : null
    )
  }

  return (
    <>
      <div className={styles.card}>
        <div className={styles.cardLeftContainer}>
          {card?.dataSource ?
            <div className={styles.ipLogo}>
              <img src={integrationPartners[card?.dataSource]?.logo} />
            </div> : null
          }
          <div className={styles.cardTitleRootContainer}>
            <div className={styles.cardTitleContainer}>
              <div className={styles.cardTitle}>
                <div className={styles.cardTitle}>
                  {card?.label}
                </div>
              </div>
            </div>
          </div>
          {iButton(card.dataSource)}

        </div>
        <div className={styles.cardRightContainer}>
          <div className={styles.value}>
            {`${card?.unit ? card?.unit : '₹'}${formatNumberWithComma(card?.currMonthValue)}`}
            {
              card.dataSource ?
                card?.isUserAltered ?
                  <span>Change requested. Merito is reviewing.</span> :
                  <span className={styles.pointer} onClick={() => updateCard(card, 'Request')}>Request Change</span>
                : null
            }
          </div>
          {
            !card.dataSource ?
              <OverlayTrigger
                placement="bottom"
                overlay={(props) => {
                  const updatedProps = {
                    ...props, maxWidth: 'max-content'
                  }
                  return (
                    <GoalsHubTooltip {...updatedProps} >
                      <p>Edit</p>
                    </GoalsHubTooltip>
                  )
                }
                }
              >
                <div>
                  <MeritoButton size='md' type='secondary-1' icon={<MdOutlineEdit />} onlyIcon={true} onClick={() => updateCard(card)} />
                </div>
              </OverlayTrigger >
              : null
          }
        </div>
      </div >
    </>
  )
}

export default SalesMarketingCardContainer;